/* global axios */
import ApiClient from './ApiClient';

class ContactBulkOperationsAPI extends ApiClient {
  constructor() {
    super('contact_bulk_operations', { accountScoped: true });
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  get(page = 1) {
    return axios.get(this.url, { params: { page } });
  }
}

export default new ContactBulkOperationsAPI();
